import { Component, OnInit, Input } from '@angular/core';
import { EmployeeData } from '../../interfaces';

@Component({
  selector: 'app-employee-avatar',
  templateUrl: './employee-avatar.component.html',
  styleUrls: ['./employee-avatar.component.scss']
})
export class EmployeeAvatarComponent implements OnInit {
  @Input() employee: EmployeeData = {} as EmployeeData;
  @Input() size: 'xs' | 'xl' = 'xs';

  constructor() {}

  ngOnInit(): void {}
}
